// extracted by mini-css-extract-plugin
export var activeAlertColor = "#166d42";
export var borderColor = "#e8e8eb";
export var dangerColor = "#fd3939";
export var darkTextColor = "#040d13";
export var defaultColor = "#04f73d";
export var greyTextColor = "#8a949d";
export var healthyAlertColor = "#166d42";
export var healthyAlertColorTint = "rgba(22,109,66,.3019607843)";
export var iconDefaultColor = "hsla(0,0%,100%,.4)";
export var inactiveAlertColor = "#7d8eaa";
export var insightAlertColor = "#166d42";
export var insightAlertColorTint = "rgba(22,109,66,.3019607843)";
export var needActionAlertColor = "#d32f2f";
export var needActionAlertColorTint = "rgba(211,47,47,.3019607843)";
export var pendingAlertColor = "#e8e8eb";
export var primaryColor = "#3f9";
export var secondaryColor = "#162029";
export var secondaryColor40 = "#d2efff";
export var secondaryTextColor = "#78899f";
export var textColor = "#040d13";
export var watchAlertColor = "#ef6c00";
export var watchAlertColorTint = "rgba(239,108,0,.3019607843)";
export var whiteColor = "#fff";